import React from 'react';
import { connect } from 'react-redux'
import { setSelectedCountry, setComparisonCountry } from '../../state/actions'
import { keys, sortBy } from 'lodash'

import SelectedCountryInput from '../SelectedCountryInput'

const mapStateToProps = state => ({
  countries: state.countries,
  indicators: state.indicators,
  selectedCountry: state.selectedCountry,
  selectedCountryData: state.selectedCountryData,
  comparisonCountry: state.comparisonCountry,
  comparisonCountryData: state.comparisonCountryData,
})

const mapDispatchToProps = { setSelectedCountry, setComparisonCountry }

export default connect(mapStateToProps, mapDispatchToProps)(class extends React.PureComponent{

  handleSelectCountry = (countryCode) => (e) => {
    this.props.setSelectedCountry(countryCode)
    if(countryCode === null && this.props.comparisonCountry){
      this.props.setSelectedCountry(this.props.comparisonCountry)
      this.props.setComparisonCountry(null)
    }
  }

  handleSelectComparisonCountry = (countryCode) => (e) => {
    this.props.setComparisonCountry(countryCode)
  }

  render(){
    const {
      setSelectedCountry, setComparisonCountry, countries,
      selectedCountry, comparisonCountry,
    } = this.props

    const countryCodes = keys(countries)
    const countryItems = sortBy(countryCodes.map(code => ({label:countries[code], value:code})), 'label')

    return (
          <div className="pv3 cf mb2 mt3">
            <div className="text-blue">
              <div><small>SELECT COUNTRY</small></div>
              <div >
                { selectedCountry===null && (
                  <SelectedCountryInput
                    countries={countries}
                    inputProps={ {className: "CountrySelector__Autocomplete--lower background-blue"} }
                    items={countryItems}
                    selectCountry={setSelectedCountry}
                    selectedCountry={selectedCountry}/>
                )}
                { selectedCountry!==null && (
                  <div className="cf" style={{paddingTop:5}}>
                    <span style={{cursor:'pointer'}} className="fl" onClick={this.handleSelectCountry(null)}>x</span>
                    <span className="fl" >{countries[selectedCountry]}</span>
                  </div>
                )}
              </div>
            </div>
            <div className="text-orange mt4 cf">
              <div><small>COMPARE WITH</small></div>
              <div>
              { comparisonCountry===null && (
                <SelectedCountryInput
                  countries={countries}
                  inputProps={ {className: "CountrySelector__Autocomplete--lower border-orange"} }
                  items={ sortBy(countryItems.filter(item => item.value !== selectedCountry), 'label') }
                  selectCountry={setComparisonCountry}
                  selectedCountry={comparisonCountry}/>
              )}
              { comparisonCountry!==null && (
                <div style={{paddingTop:5}}>
                  <span style={{cursor:'pointer'}} className="fl" onClick={this.handleSelectComparisonCountry(null)}>x</span>
                  <span className="fl">{countries[comparisonCountry]}</span>
                </div>
              )}
              </div>
            </div>
            <div className="cf"></div>


          </div>

    )

  }
})



// WEBPACK FOOTER //
// ./src/components/SideCountriesSelector/index.js